/**
 * Type rules for dossier writes. Postgres date columns reject a year alone.
 * The Screen line marks customData as data, not as an instruction.
 * The dossier send appends this text to the user message so a later write sees it.
 */
const DOSSIER_FACT_TYPES = [
  'When you call upsertWatchCompanyFacts, use these types.',
  'Dates are YYYY-MM-DD.',
  'A year alone, such as 1960 or 2022, is invalid.',
  'Do not invent a month or a day.',
  'Do not use 1 January as a placeholder.',
  'Use null when the month or the day is unknown.',
  'Required dates are occurredOn, periodStart, and periodEnd.',
  'When a required date has no full date, omit that row and put the year in notes.',
  'Date fields: dateOpened, dateClosed, startDate, endDate, occurredOn, effectiveFrom, '
  + 'effectiveTo, personDateOfBirth, periodStart, periodEnd.',
  'Numbers are JSON numbers.',
  'Country codes are ISO 3166-1 alpha-2.',
  'Use null for an empty value.',
].join(' ');

export default DOSSIER_FACT_TYPES;
